<template>
  <div class="not-order">
    <img src="~assets/img/null.png"/>
    <div>
      <p style="line-height: 44px">
        <span class="null_top span">{{tip}}</span>
      </p>
      <p v-if="show">
        <router-link class="null_bottom f16" v-if="isRouter" :to="url">{{btnWord}}</router-link>
        <a v-else class="null_bottom f16" :href="url">{{btnWord}}</a>
      </p>

    </div>
  </div>
</template>

<script>
export default {
  name: 'cc-not-order',
  props: {
    tip: {
      default: '亲，暂无相关订单哦'
    },
    url: {
      type: String,
      default: '/home/index'
    },
    isRouter: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    },
    btnWord: {
      type: String,
      default: '去逛逛'
    }
  }
}
</script>

<style lang="scss" scoped>
.not-order {
  text-align: center;
  > img {
    display: inline-block;
    width: 120px;
    height: 120px;
    margin-top: 50px;
  }
}
</style>
